import {Card, CardContent, CardMedia, CardProps, Stack, Typography} from "@mui/material";
import {WorkInstanceDocument} from "../../../../types/pj1dbApiWork";
import {pickImageUrl} from "../../../../utils/workUtil";
import {MODEL_BG_COLOR, WORK_ATTRS} from "../../../../constants/work";

export interface WorkInstanceListItemProps extends CardProps {
  item: WorkInstanceDocument;
}

export default function WorkInstanceListItem({item, ...props}: WorkInstanceListItemProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Card {...props} sx={{p: 0, m: 0, width: 240, height: '100%', ...props.sx}}>
      <CardMedia
        component="img"
        height="145"
        image={pickImageUrl(item)}
        alt={item.attr[WORK_ATTRS.description.key]}
        sx={{objectFit: "scale-down", backgroundColor: MODEL_BG_COLOR}}
      />
      <CardContent sx={{pt: 1, px: 1}}>
        <Stack gap={1}>
          <Typography variant="subtitle2" component='p' sx={{overflowWrap: 'break-word'}}>
            （説明）{item.attr[WORK_ATTRS.description.key]}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  )
}
